import { useState, useEffect, useRef } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
  Card,
  CardContent,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { removeFromCart, updateQuantity } from "../../Store/slices/cartSlice";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";

const Shopping = ({ cart }) => {
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const mainContentRef = useRef(null);
  const [subAmount, setSubAmount] = useState(0);
  const [branch_id, setBranch_id] = useState("");
  const [isFree, setIsFree] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [userRole, setUserRole] = useState("");
  //TODO: GET all student
  const [students, setStudents] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);

  useEffect(() => {
    const fetchStudents = async () => {
      setLoadingStudents(true);
      try {
        const response = await fetch(
          "https://api.clever-school.com/api/students",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch students");
        const data = await response.json();

        const rawData = data.data || data;
        setDataSource(Array.isArray(rawData) ? rawData : []);
      } catch (error) {
        // console.error("Error fetching students:", error);
        // message.error(t("studentLoadError"));
        setDataSource([]);
      } finally {
        setLoadingStudents(false);
      }
    };

    fetchStudents();
  }, [token, t]);

  // eslint-disable-next-line no-unused-vars
  const [userBranch, setUserBranch] = useState("");
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setUserRole(user.role);
        setUserBranch(user.branch_id);

        // Set branch_id automatically for non-superadmins
        if (user.role !== "superadmin") {
          setBranch_id(user.branch_id);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);
  const getTranslatedName = (nameInput) => nameInput || "Unnamed Product";

  useEffect(() => {
    let total_price = 0;
    cart.forEach((item) => {
      total_price += item.quantity * item.price;
    });
    setSubAmount(total_price);
  }, [cart]);

  const confirm = async () => {
    const API_URL = "https://api.clever-school.com/api/uniforms/create-order";
    const orderJson = {
      student_id: students,
      branch_id: branch_id,
      is_free: isFree,
      order_uniforms: cart.map(({ id, quantity, price }) => ({
        uniform_id: id,
        quantity,
        single_price: price,
      })),
    };
    // console.log("Sending order data:", {
    //   student_id: students,
    //   branch_id: branch_id,
    //   is_free: isFree,
    //   cart_items: cart.map((item) => ({
    //     id: item.id,
    //     name: item.name,
    //     quantity: item.quantity,
    //     price: item.price,
    //   })),
    // });
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(orderJson),
      });

      const result = await response.json();
      if (!response.ok) {
        message.error(result.message || "Failed to place order");
        return;
      }
      window.location.href = "/GetProducts";
      message.success("Order placed successfully");
    } catch (error) {
      message.error("Failed to place order");
    }
  };

  const isMobile = window.innerWidth <= 768;

  const handleRemove = (id) => {
    dispatch(removeFromCart(id));
  };

  const handleUpdateQuantity = (itemId, change) => {
    const item = cart.find((item) => item.id === itemId);
    if (!item) return;

    if (change > 0 && item.quantity + change > item.stock) {
      alert(t("Cannot add more than {stock} items.", { stock: item.stock }));
      return;
    }

    if (item.quantity + change < 1) {
      alert("Quantity cannot be less than 1.");
      return;
    }

    dispatch(updateQuantity({ itemId, change }));
  };

  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";
  return (
    <Box sx={{ padding: 3, maxWidth: "1200px", margin: "auto" }}>
      {cart.length > 0 ? (
        <>
          <Box
            sx={{
              direction,
              textAlign,
              overflowX: "auto",
              background: "#fff",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Box sx={{ width: "100%", overflowX: "auto" }}>
              <Table sx={{ minWidth: isMobile ? "600px" : "100%" }}>
                <TableHead>
                  <TableRow sx={{ background: "#f5f5f5" }}>
                    {["Product", "Quantity", "Price", "Remove"].map((key) => (
                      <TableCell
                        key={key}
                        sx={{
                          fontSize: isMobile ? "14px" : "16px",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {t(key)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cart.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {getTranslatedName(item.name)}
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={() => handleUpdateQuantity(item.id, 1)}
                          sx={{
                            minWidth: "35px",
                            background: "#007bff",
                            color: "#fff",
                            "&:hover": { background: "#0056b3" },
                          }}
                        >
                          +
                        </Button>
                        <span
                          style={{
                            margin: "0 10px",
                            fontSize: isMobile ? "14px" : "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {item.quantity}
                        </span>
                        <Button
                          onClick={() => handleUpdateQuantity(item.id, -1)}
                          sx={{
                            minWidth: "35px",
                            background: "#ff4444",
                            color: "#fff",
                            "&:hover": { background: "#cc0000" },
                          }}
                        >
                          -
                        </Button>
                      </TableCell>
                      {/* <TableCell>IQD {item.price}</TableCell> */}
                      <TableCell>
                        IQD {(item.price * item.quantity).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={() => handleRemove(item.id)}
                          sx={{
                            background: "#fa4032",
                            color: "white",
                            "&:hover": { background: "#d32f2f" },
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>

          <Typography
            variant="h6"
            color="green"
            align="center"
            sx={{ marginTop: 3 }}
          >
            {t("Total:")}Total IQD {subAmount}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              mt: 3,
            }}
          >
            {/* Free/Paid Buttons */}
            <Button
              variant={isFree === 0 ? "contained" : "outlined"}
              onClick={() => setIsFree(0)}
              sx={{
                minWidth: 120,
                padding: "8px 20px",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
                textTransform: "capitalize",
                transition: "0.3s",
                "&:hover": { background: "#0056b3", color: "#fff" },
              }}
            >
              {t("Free")}
            </Button>

            <Button
              variant={isFree === 1 ? "contained" : "outlined"}
              onClick={() => setIsFree(1)}
              sx={{
                minWidth: 120,
                padding: "8px 20px",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
                textTransform: "capitalize",
                transition: "0.3s",
                "&:hover": { background: "#28a745", color: "#fff" },
              }}
            >
              {t("Paid")}
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              mt: 3,
            }}
          >
            <Card
              variant="outlined"
              sx={{
                width: "40%",
                maxWidth: 500,
                mt: 2,
                borderRadius: "12px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                borderColor: "#eee",
              }}
            >
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  sx={{
                    fontWeight: 600,
                    mb: 1.5,
                    fontSize: "14px",
                    color: "text.secondary",
                  }}
                >
                  {t("students")}
                </Typography>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{
                      color: "text.secondary",
                      fontSize: "16px",
                      "&.Mui-focused": {
                        color: "primary.main",
                      },
                    }}
                  >
                    {loadingStudents ? t("loading...") : t("selectStudent")}
                  </InputLabel>
                  <Select
                    value={students}
                    onChange={(e) => setStudents(e.target.value)}
                    label={t("students")}
                    disabled={loadingStudents}
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        fontSize: "16px",
                        padding: "12px 14px",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#ccc",
                          borderRadius: "8px",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.main",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                          mt: 1,
                          "& .MuiMenuItem-root": {
                            fontSize: "14px",
                            padding: "10px 16px",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                        },
                      },
                    }}
                  >
                    {loadingStudents && (
                      <MenuItem
                        disabled
                        sx={{ fontSize: "14px", color: "text.secondary" }}
                      >
                        {t("loading...")}
                      </MenuItem>
                    )}
                    {dataSource.map((student) => (
                      <MenuItem
                        key={student.id}
                        value={student.id}
                        sx={{ fontSize: "14px", py: 1 }}
                      >
                        {student.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </CardContent>
            </Card>

            {/* Branch Selection Card */}
            {userRole === "superadmin" && (
              <Card
                variant="outlined"
                sx={{
                  width: "40%",
                  maxWidth: 500,
                  mt: 2,
                  borderRadius: "12px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  borderColor: "#eee",
                }}
              >
                <CardContent>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    sx={{
                      fontWeight: 600,
                      mb: 1.5,
                      fontSize: "14px",
                      color: "text.secondary",
                    }}
                  >
                    {t("Branch")}
                  </Typography>
                  <Select
                    fullWidth
                    value={branch_id}
                    onChange={(e) => setBranch_id(e.target.value)}
                    displayEmpty
                    required
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        fontSize: "16px",
                        padding: "12px 14px",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#ccc",
                          borderRadius: "8px",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.main",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                          borderWidth: "2px",
                        },
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: "8px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                          mt: 1,
                          "& .MuiMenuItem-root": {
                            fontSize: "14px",
                            padding: "10px 16px",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="" disabled sx={{ fontSize: "14px" }}>
                      {t("selectBranch")}
                    </MenuItem>
                    <MenuItem value={1} sx={{ fontSize: "14px", py: 1 }}>
                      {t("Nursery")}
                    </MenuItem>
                    <MenuItem value={2} sx={{ fontSize: "14px", py: 1 }}>
                      {t("Primary School")}
                    </MenuItem>
                    <MenuItem value={3} sx={{ fontSize: "14px", py: 1 }}>
                      {t("Secondary School")}
                    </MenuItem>
                  </Select>
                </CardContent>
              </Card>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 3,
              marginBottom: 10,
            }}
          >
            <Button variant="contained" onClick={confirm}>
              {t("Confirm Order")}
            </Button>
          </Box>
        </>
      ) : (
        <Typography variant="h4" align="center">
          {t("Your cart is empty.")}
          <br />
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/GetProducts")} // Redirect to the products page
          >
            {t("Back to Products")}
          </Button>
        </Typography>
      )}
    </Box>
  );
};

export default Shopping;
